export const MAP_ERROR_MESSAGE_MODAL_ID = 'map-error-message-modal'
